import { render, staticRenderFns } from "./image-tint.vue?vue&type=template&id=2509d2fa&scoped=true"
import script from "./image-tint.vue?vue&type=script&lang=js"
export * from "./image-tint.vue?vue&type=script&lang=js"
import style0 from "./image-tint.vue?vue&type=style&index=0&id=2509d2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2509d2fa",
  null
  
)

export default component.exports